import { cn } from '@/lib/utils/utils'
import MD from '../markdown'
import { Glossary } from './glossary'
import { LangCode } from '../i18n/lang-context'

export function SectionTitle({ title, desc, langCode, className, titleText = 'text-2xl sm:text-3xl', titleMaxWidth = 'max-w-3xl', descText = 'sm:text-lg', descMaxWidth = 'max-w-3xl', mainTitle = false, glossary }:
  { title?: string, desc?: string, langCode: LangCode, contrast?: boolean, className?: string, titleText?: string, titleMaxWidth?: string, descText?: string, descMaxWidth?: string, mainTitle?: boolean, glossary?: Glossary }) {

  return (
    <div id='SECTION_TITLE' className={cn('flex w-full flex-col items-center gap-8 pt-4', className)}>
      {title && (mainTitle ? <h1 id='TITLE' className={cn('text-center font-bold', titleText, titleMaxWidth)}>
        <MD textAlign='center' glossary={glossary} langCode={langCode}>{title}</MD>
      </h1> : <h2 id='SUB_TITLE' className={cn('text-center font-bold', titleText, titleMaxWidth)}>
        <MD textAlign='center' glossary={glossary} langCode={langCode}>{title}</MD>
      </h2>)}
      {desc && <div id='DESC' className={cn('text-center', descText, descMaxWidth)}>
        <MD textAlign='center' glossary={glossary} langCode={langCode}>{desc}</MD>
      </div>}
    </div>
  )
}
